<template>
  <div class="table-container">
    <div class="top-cont">
      <div class="h1">（{{route.query.acctName}}）{{t('client.accountTable.text_10')}}</div>
      <el-button type="primary" text bg
        @click="back">{{t('client.accountTable.text_9')}}</el-button>
    </div>
    <el-table row-class-name="row-con"
      :data="tbl.data.list"
      v-loading="tbl.data.loading"
      :default-sort="{ prop: 'status', order: 'descending' }"
      >
      <sr-tbl-column :columns="tbl.columns">
        <template #countryCode="scope">
          <div v-if="scope.row.countryCode">
            <div>{{ecCountryCode[scope.row.countryCode]}}</div>
          </div>
          <div v-else>-</div>
        </template>
        <template #storePlatform="scope">
          <div v-if="scope.row.storePlatform">
            <div>{{storePlatform[scope.row.storePlatform]}}</div>
          </div>
          <div v-else>-</div>
        </template>
        <template #supportCur="scope">
          <div v-if="scope.row.supportCur.includes(',')">
            <el-tooltip placement="top">
              <template #content>{{scope.row.supportCur}}</template>
              <div>多币种</div>
            </el-tooltip>
          </div>
          <div v-else>{{scope.row.supportCur}}</div>
        </template>
      </sr-tbl-column>
       <el-table-column prop="custBankCardNo" label="收款账号">
        <template #header>
          <div class="bank-card-header">
            <span>收款账号</span>
            <!-- <el-icon class="eye-icon" @click="toggleBankCardVisibility">
              <View v-if="showBankCardNo" />
              <Hide v-else />
            </el-icon> -->
          </div>
        </template>
        <template #default="{ row }">
          <span v-if="showBankCardNo">{{ row.custBankCardNo }}</span>
          <span v-else>{{ maskText(row.custBankCardNo, 'table2') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" sortable align="center" show-overflow-tooltip :label="t('client.accountTable.text_7')" >
        <template #default="scope">
          <div class="header-cell">
            <el-tag :type="statTag[scope.row.status]" v-if="scope.row.status">
              {{accountStatus[scope.row.status]}}
            </el-tag>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sysTxnTime" sortable  align="center" show-overflow-tooltip :label="t('client.accountTable.text_8')" >
        <template #default="scope">
          <div class="header-cell" v-if="scope.row.sysTxnTime">
            {{scope.row.sysTxnTime}}
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="activeTime" sortable  align="center" show-overflow-tooltip :label="t('client.accountTable.text_11')" >
        <template #default="scope">
          <div class="header-cell" v-if="scope.row.activeTime">
            {{scope.row.activeTime}}
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <sr-tbl-pagination v-model:current-page="tbl.pagination.currentPage"
      v-model:page-size="tbl.pagination.pageSize"
      :total="tbl.pagination.total"
      @fetchData="fetchData">
    </sr-tbl-pagination>
  </div>
</template>
<script setup>
import { useStore } from "vuex";
import tableComp from "@/compositions/modules/table";
import SrTblColumn from "@/components/SrTblColumn";
import { components } from '@libs/ui'
import { ref, reactive } from "vue";
import { routeTo, maskText } from "@/utils";
import { useI18n } from "@/plugins/i18n";
import { dataUtils } from "@libs/utils";
import { useRoute } from "vue-router";
import { accountList } from "@/api/modules/list"
import { accountStatus, statTag } from "@/domain/modules/client-options"
const SrTblPagination = components.SrTblPagination
const { createTable } = tableComp();
const { t } = useI18n();
const route = useRoute();
const store = useStore();
const { ecCountryCode, storePlatform } = store.state.base.dict
const showBankCardNo = ref(false)
const columnsTemp = [
  { prop: 'storeName', label: t('client.accountTable.text_1'), align: 'left' },
  { slot: "storePlatform", align: "left", label: t('client.accountTable.text_2') },
  { slot: "countryCode", align: "left", label: t('client.accountTable.text_3') },
  { slot: "supportCur", align: "center", label: t('client.accountTable.text_4') },
];
const tbl = createTable({
  columns: columnsTemp
});
const pageInfo = reactive({
  current: 1,
  size: 10,
  total: 0
})
const back = () => {
  routeTo('/client/list')
}
const toggleBankCardVisibility = () => {
  showBankCardNo.value = !showBankCardNo.value
}
const fetchData = async () => {
  const params = {
    pageInfo: {
      current: tbl.pagination.currentPage,
      size: tbl.pagination.pageSize,
    },
    acctId: route.query.acctId,
  };
  tbl.data.loading = true;
  tbl.data.list = [];
  try {
    const { list, pageInfo: { total } } = await accountList(params);
    tbl.data.list = list.map((item) => ({
      ...item,
      sysTxnTime: dataUtils.formatDate(
        item.sysTxnTime,
        "YYYY-MM-DD"
      ),
      activeTime: dataUtils.formatDate(
        item.activeTime,
        "YYYY-MM-DD"
      ),
    }));
    tbl.pagination.total = total;
  } finally {
    tbl.data.loading = false;
  }
}
fetchData()
</script>
<style lang="scss" scoped rel="stylesheet/scss">
.bank-card-header {
  display: flex;
  align-items: center;
}
.top-cont {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  padding: 30px 20px;

  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 160px auto;
    box-sizing: border-box;

    & > img {
      width: 190px;
      height: auto;
      display: block;
      margin-bottom: 38px;
    }
  }

  :deep(.row-con) {
    height: 57px;
  }
}
</style>
